import axios from "axios";

export default function ProjectitemFormService(formData, method, projectId) {
  let id
  let url
  if(method === 'put') {
    id = formData.id
    url = process.env.REACT_APP_API_HOST + "/project/" + projectId + "/product/" + id
  }
  else {
    url = process.env.REACT_APP_API_HOST + "/project/" + projectId + "/products"
  }
  return axios({
    method: method,
    url: url,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
